import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvancedTreeFilterPipe } from './advanced-tree-filter.pipe';



@NgModule({
  declarations: [AdvancedTreeFilterPipe],
  exports: [AdvancedTreeFilterPipe],
  imports: [
    CommonModule
  ]
})
export class AdvancedTreeFilterModule { }
